import { render } from "./Supporters.vue?vue&type=template&id=342e4eb1&scoped=true&ts=true"
import script from "./Supporters.vue?vue&type=script&lang=ts"
export * from "./Supporters.vue?vue&type=script&lang=ts"

import "./Supporters.vue?vue&type=style&index=0&id=342e4eb1&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-342e4eb1"]])

export default __exports__